import { inject, makeStateKey, Provider, TransferState } from '@angular/core';

import env from 'zenith/env';

import { GA_MEASUREMENT_ID } from '@core/token/analytics.token';

const GA_STATE_KEY = makeStateKey<string>('ga-measurement-id');

export function provideAnalyticsConfig(): Provider[] {
  return [
    {
      provide: GA_MEASUREMENT_ID,
      useFactory: () => {
        const transferState = inject(TransferState);

        if (transferState.hasKey(GA_STATE_KEY)) {
          return transferState.get(GA_STATE_KEY, '');
        }

        const id = env.GA_MEASUREMENT_ID ?? '';
        transferState.set(GA_STATE_KEY, id);
        return id;
      },
    },
  ];
}
